import React from 'react';

import _ from 'lodash';

import paginationFactory from 'react-bootstrap-table2-paginator';
import BootstrapTable from 'react-bootstrap-table-next';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css';
import date from '../../utils/date'
const SubscriptionsList = params => {
    const { SearchBar } = Search;

    const customTotal = (from, to, size) => (
        <span className="react-bootstrap-table-pagination-total">
            Showing { from} to { to} of { size} Results
        </span>
    );

    const options = {
        paginationTotalRenderer: customTotal,
        showTotal: true,
        onSizePerPageChange: (sizePerPage, page) => {
            // console.log('Size per page change!!!');
            // console.log('Newest size per page:' + sizePerPage);
            // console.log('Newest page:' + page);
        },
        onPageChange: (page, sizePerPage) => {
            // console.log('Page change!!!');
            // console.log('Newest size per page:' + sizePerPage);
            // console.log('Newest page:' + page);
        }
    };
    const columns = [
        {
            text: '#',
            dataField: 'rowNumber',
            isDummyField: true,
            formatter: indexFormatter,
        },
        {
            text: 'Status',
            dataField: `status`,
            formatter: statusFormatter,
        },
        {
            text: 'Plan',
            dataField: 'plan',
            formatter: planFormatter,
        },
        {
            text: 'Amount',
            dataField: 'planAmount',
            isDummyField: true,
            formatter: amountFormatter,
        },
        {
            text: 'Bought Date',
            dataField: 'startDate',
            formatter: boughtDateFormatter,
        },
        {
            text: 'Start Date',
            dataField: 'currentPeriodStart',
            formatter: dateFormatter,
        },
        {
            text: 'End Date',
            dataField: 'currentPeriodEnd',
            formatter: dateFormatter,
            sort: true,
        },
        // {
        //     text: 'Action',
        //     dataField: '_id',
        //     formatter: actionFormatter,
        // }
    ]

    function indexFormatter(cell, row, index) {
        return (
            index + 1
        )
    }
    function statusFormatter(cell, row) {
        const today = new Date();
        const expDate = new Date(row.currentPeriodEnd);
        return (
            (expDate < today && cell === 'active') || cell === 'past_due' ? <span className="danger">Expired</span>
                : (cell === 'unpaid' || cell === 'canceled' ? <span className="danger">{_.startCase(cell)}</span> : _.startCase(cell))
        )
    }
    function planFormatter(plan, row) {

        return (
            `${plan.intervalCount} ${_.startCase(plan.interval)}`
        )
    }
    function amountFormatter(cell, row) {
        const plan = row.plan;

        return (
            plan && plan.amount === 0 ? 'Free' : (plan ? `${plan.amount} ${plan.currency}` : '-')
        )
    }
    function boughtDateFormatter(cell, row) {
        return (date(cell))
    }

    function dateFormatter(cell, row) {
        return (row.status === 'unpaid' || row.status === 'canceled' ? '-' : date(cell))
    }
    return (
        <ToolkitProvider
            keyField="_id"
            data={params.data ? params.data : []}
            columns={columns}
            search
        >
            {
                props => (
                    <div>
                        <SearchBar {...props.searchProps} />
                        <hr />
                        <BootstrapTable
                            {...props.baseProps}
                            pagination={paginationFactory(options)}
                        />
                    </div>
                )
            }
        </ToolkitProvider>

    )
}

export default SubscriptionsList;
